import { NButton } from '@nemo/react';
import { formatWeekRange } from '../../utils/utils';

interface TableHeaderProps {
  navigateWeek: (direction: 'previous' | 'next') => void;
  selectedDates: Date[];
  isPreviousArrowBtnDisabled: () => boolean;
}

function TableHeader({
  navigateWeek,
  selectedDates,
  isPreviousArrowBtnDisabled,
}: TableHeaderProps) {
  return (
    <section className="table-header-section">
      <div className="week-nav flex align-center">
        <NButton
          variant="quaternary"
          icon-only
          iconName="caret-left"
          size="sm"
          style={{ filter: isPreviousArrowBtnDisabled() ? 'opacity(0.5)' : 'opacity(1)' }}
          onClick={() => navigateWeek('previous')}
        />
        <NButton
          variant="quaternary"
          icon-only
          iconName="caret-right"
          size="sm"
          onClick={() => navigateWeek('next')}
        />
        <h6> {formatWeekRange(selectedDates)}</h6>
      </div>
      <div className="table-column-titles">
        <div className="time">
          <p className="b2">Time</p>
        </div>
        <div className="duration">
          <p className="b2">Duration</p>
        </div>
        <div className="group">
          <p className="b2">Group</p>
        </div>
        <div className="topic">
          <p className="b2">Topic</p>
        </div>
        <div className="resources">
          <p className="b2">Resources</p>
        </div>
      </div>
    </section>
  );
}

export default TableHeader;
